export default "__VITE_ASSET__Cm93jH60__"